// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_RemoverResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for POST /so/products/remover — returns null dados on success.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Products_RemoverResponseDados = null;

export type Products_RemoverResponse = ApiResponse<Products_RemoverResponseDados>;

registerResponseContract('Products_RemoverResponse', {})
